import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import { useLocation } from "react-router-dom";

import EventListChild from "./EventListChild";

const EventList = () => {
  let rowdata = useLocation();
  let guestRecord = rowdata.state;
  return (
    <MainTemplate>
      <CardBackground>
        <EventListChild guestRecord={guestRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventList;
